<template>
  <div>
    <header class="l-contents-header">
      <a href="javascript:void(0)" class="search-time" @click="toggleMonthSearch()">時系列</a>
      <form @submit.prevent class="search-form">
        <input class="input-text" type="text" list="searchInput" placeholder="エリア・ジャンル検索" v-model="keyword">
        <div class="input-clear-btn" @click="clearSearchKeywords()" v-show="!!keyword"></div>
        <button type="submit" class="search-button" @click="search()">search</button>
        <button class="search-clear-button" v-show="this.$store.getters['search/getSearchWord']" @click="clearSearch()">クリア</button>
      </form>
      <datalist id="searchInput">
        <option value="大使館"></option>
        <option value="ショッピング"></option>
        <option value="ファッション"></option>
        <option value="学校"></option>
        <option value="スタジオ"></option>
        <option value="イベント"></option>
        <option value="神社"></option>
        <option value="待ち合わせ"></option>
      </datalist>
      <a href="javascript:void(0)" class="menu-trigger" :class="{active: $store.getters['spMenu/getActiveMenu']}" @click="toggleSideMenu()">
        <span></span>
        <span></span>
        <span></span>
      </a>
      <div class="overlay-all" :class="{active: $store.getters['spMenu/getActiveMenu'] === true || $store.getters['modal/getModal'] !== ''}" @click="closeElement()"></div>
    </header>
    <div class="time-search-wrap" v-show="showMonthSearch">
      <p class="month-search">月別検索</p>
      <ul class="time-list-wrap">
        <li v-for="(value, key) in 12" :key="key" class="time-list">
          <input type="checkbox" :value="value" :id="'month-' + key" @click="onMonthClicked(value)">
          <label :for="'month-' + key">{{ value }}</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import utils from '../../../utils/vue/Utils'
import storage from '../../../utils/vue/LocalStorage'

export default {
  name: 'comp-header',
  data () {
    return {
      keyword: '',
      showMonthSearch: false,
      searchMonths: []
    }
  },
  computed: {
    searchWord () {
      return this.$store.getters['search/getSearchWord']
    }
  },
  watch: {
    searchWord () {
      this.keyword = this.$store.getters['search/getSearchWord']
    }
  },
  methods: {
    search () {
      this.store.dispatch('search/setSearchWord', this.keyword)
      this.setItem('searching', true)
      this.getMarkerCoordinates()
    },
    toggleSideMenu () {
      this.showMonthSearch = false
      this.$store.dispatch('spMenu/setActiveMenu', !this.$store.getters['spMenu/getActiveMenu'])
    },
    toggleMonthSearch () {
      this.$store.dispatch('modal/setModal', '')
      this.$store.dispatch('spMenu/setActiveMenu', false)
      this.showMonthSearch = !this.showMonthSearch
    },
    onMonthClicked (value) {
      const existedIdx = this.searchMonths.findIndex(_ => _ === value)
      if (existedIdx >= 0) {
        this.searchMonths.splice(existedIdx, 1)
      } else {
        this.searchMonths.push(value)
      }
      const monthsInStr = this.searchMonths.length === 0 ? Array.from(new Array(12), (val, index) => index + 1).join() : this.searchMonths.join()
      this.store.dispatch('search/setMonths', monthsInStr)
      this.getMarkerCoordinates()
    },
    clearSearchKeywords () {
      this.keyword = ''
    },
    clearSearch () {
      this.keyword = ''
      this.search()
    }
  },
  mixins: [utils, storage]
}
</script>

<style lang="scss" scoped src="../scss/CompHeader.scss"></style>



// WEBPACK FOOTER //
// src/components/shared/vue/CompHeader.vue